module.exports = substance;